import React, { Component } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import { Container, Form, Modal, InputGroup } from "react-bootstrap";
import Moment from "moment";
import Select from "react-select";
import SimplifiLeadService from "../../services/SimplifiLeadService";
import Alerts from "../common/Alerts";
import CalendarSidebar from "../common/CalendarSidebar";
import AllPropertyReservationSidebar from "../common/AllPropertyReservationSidebar";
import filterIcon from "./../../assets/images/filter-gray.svg";
import OutSidePropertySelectBox from "../outside-modules/OutSidePropertySelectBox";
import Nodata from "../../assets/images/to-do.png";
import {
  formatMarketingConversionPrice,
  getMarketingConversionEventLabel,
} from "./marketingConversionEventLabels";

class SimplifiLeads extends Component {
  constructor(props) {
    super(props);
    this.state = {
      property_slug: this.props.match.params.propertySlug,
      records: [],
      total_record: 0,
      loading: false,
      filter_value: "",
      filter_time: null,
      customQueryString: "",
      isSearch: false,
      is_search: 0,
      module_search: [],
      event_type: "",
      status: "",
      selectedEventTypeList: [],
      selectedStatusList: [],
      newEventTypeList: [
        {
          key: "lead_visit",
          value: "lead_visit",
          label: "Lead Visit",
        },
        {
          key: "lead_created",
          value: "lead_created",
          label: "Lead Created",
        },
        {
          key: "booking_initiated",
          value: "booking_initiated",
          label: "Booking Initiated – No Payment",
        },
        {
          key: "reservation_completed",
          value: "reservation_completed",
          label: "Reservation Completed – Payment Successful",
        },
      ],
      newStatusList: [
        { key: "pending", value: "pending", label: "Pending" },
        { key: "sent", value: "sent", label: "Sent" },
        { key: "failed", value: "failed", label: "Failed" },
        { key: "dead", value: "dead", label: "Dead" },
      ],
      click_id: "",
      reservation_slug: "",
      showAlertModal: false,
      alertModalType: "",
      alertModalTitle: "",
      alertModalMessage: "",
      config: {
        sort: {
          column: "created_at",
          order: "desc",
        },
        key_column: "slug",
        page_size: global.page_size,
        length_menu: global.page_length_menu,
        show_length_menu: true,
        show_filter: false,
        show_pagination: global.show_pagination,
        pagination: "advance",
        button: {
          excel: global.excel_button,
          print: global.print_button,
          extra: false,
        },
        language: {
          no_data_text: "No marketing conversion events found",
        },
      },
      extraButtons: [],
      columns: [
        {
          key: "provider",
          text: "Provider",
          sortable: true,
          className: "hand-cursor td_clickable text-capitalize",
          cell: (record) => (record.provider ? record.provider : "-"),
        },
        {
          key: "event_type",
          text: "Event Type",
          sortable: true,
          className: "hand-cursor td_clickable text-capitalize",
          cell: (record) => getMarketingConversionEventLabel(record.event_type),
        },
        // {
        //   key: "status",
        //   text: "Status",
        //   sortable: true,
        //   className: "hand-cursor td_clickable text-capitalize",
        // },
        // {
        //   key: "click_id",
        //   text: "Click ID",
        //   sortable: false,
        //   className: "hand-cursor td_clickable",
        //   cell: (record) => (record.click_id ? record.click_id : "-"),
        // },
        {
          key: "confirmation_code",
          text: "Confirmation Code",
          sortable: false,
          className: "hand-cursor td_clickable",
          cell: (record) =>
            record.confirmation_code ? record.confirmation_code : "-",
        },
        {
          key: "total_amount",
          text: "Price",
          sortable: false,
          className: "hand-cursor td_clickable",
          cell: (record) => formatMarketingConversionPrice(record.total_amount),
        },
        // {
        //   key: "sent_at",
        //   text: "Sent At",
        //   sortable: true,
        //   className: "hand-cursor td_clickable",
        //   cell: (record) =>
        //     record.sent_at
        //       ? Moment(record.sent_at).format(global.dateTimeFormat)
        //       : "-",
        // },
        {
          key: "created_at",
          text: "Created",
          sortable: true,
          className: "hand-cursor td_clickable",
          cell: (record) =>
            record.created_at
              ? Moment(record.created_at).format(global.dateTimeFormat)
              : "",
        },
      ],
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData = async (queryString = "") => {
    this.setState({ loading: true });

    const baseQuery =
      "property_slug=" +
      (this.state.property_slug ? this.state.property_slug : "") +
      "&sort_column=created_at&sort_order=desc";
    const finalQuery = baseQuery + (queryString ? "&" + queryString : "");

    let list = [];
    let totalRecords = 0;
    const res = await SimplifiLeadService.getLeadList(finalQuery);
    if (global.successStatus.includes(res.status)) {
      list = res.data && res.data.data ? res.data.data : [];
      totalRecords = res.data && res.data.total ? res.data.total : 0;
    } else {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error",
        alertModalMessage: res.message ? res.message : "Unable to load records",
      });
    }

    this.setState({
      records: list,
      total_record: totalRecords,
      loading: false,
    });
  };

  tableChangeHandler = (data) => {
    let queryString = Object.keys(data)
      .map((key) => {
        if (key === "sort_order" && data[key]) {
          return (
            encodeURIComponent("sort_order") +
            "=" +
            encodeURIComponent(data[key].order) +
            "&" +
            encodeURIComponent("sort_column") +
            "=" +
            encodeURIComponent(data[key].column)
          );
        }
        let newKey = key;
        if (key === "page_number") {
          newKey = "page";
          window.scrollTo(0, 0);
        } else if (key === "page_size") {
          newKey = "per_page";
        } else if (key === "sort_order") {
          data[key] = "asc";
        }
        return encodeURIComponent(newKey) + "=" + encodeURIComponent(data[key]);
      })
      .join("&");

    if (data.filter_value !== "") {
      this.setState({ tableQueryString: queryString });
    } else {
      if (this.state.customQueryString) {
        queryString += "&" + this.state.customQueryString;
      }
      this.setState({ tableQueryString: queryString });
    }

    if (data.filter_value !== this.state.filter_value) {
      clearTimeout(this.state.filter_time);
      this.setState({
        filter_time: setTimeout(
          () => this.getData(queryString),
          global.filter_time,
        ),
        filter_value: data.filter_value,
      });
    } else {
      this.getData(queryString);
    }
  };

  getPropertySlug(property_slug) {
    this.setState(
      {
        property_slug: property_slug,
        module_search: [],
        is_search: 0,
        customQueryString: "",
        filter_value: "",
        event_type: "",
        status: "",
        selectedEventTypeList: [],
        selectedStatusList: [],
        click_id: "",
        reservation_slug: "",
      },
      () => this.getData(),
    );
  }

  changeHandler = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  searchToggle = () => {
    this.setState({ isSearch: !this.state.isSearch });
  };

  handleChangeEventType = (value) => {
    this.setState({
      selectedEventTypeList: value,
      event_type: value && value.value ? value.value : "",
    });
  };

  handleChangeStatus = (value) => {
    this.setState({
      selectedStatusList: value,
      status: value && value.value ? value.value : "",
    });
  };

  filterData = () => {
    const queryParts = [];
    const moduleSearch = [];

    if (this.state.event_type) {
      queryParts.push(
        "event_type=" + encodeURIComponent(this.state.event_type),
      );
      moduleSearch.push("Event Type - " + this.state.event_type);
    }

    if (this.state.status) {
      queryParts.push("status=" + encodeURIComponent(this.state.status));
      moduleSearch.push("Status - " + this.state.status);
    }

    if (this.state.click_id) {
      queryParts.push("click_id=" + encodeURIComponent(this.state.click_id));
      moduleSearch.push("Click ID - " + this.state.click_id);
    }

    if (this.state.reservation_slug) {
      queryParts.push(
        "filter_value=" + encodeURIComponent(this.state.reservation_slug),
      );
      moduleSearch.push("Reservation - " + this.state.reservation_slug);
    }

    const queryString = queryParts.join("&");
    this.setState(
      {
        customQueryString: queryString,
        module_search: moduleSearch,
        is_search: moduleSearch.length > 0 ? 1 : 0,
        isSearch: false,
      },
      () => this.getData(queryString),
    );
  };

  clearFilter = () => {
    this.setState(
      {
        module_search: [],
        is_search: 0,
        customQueryString: "",
        filter_value: "",
        event_type: "",
        status: "",
        selectedEventTypeList: [],
        selectedStatusList: [],
        click_id: "",
        reservation_slug: "",
      },
      () => this.getData(),
    );
  };

  rowClickedHandler = (data) => {
    if (!data) {
      return "";
    }

    const slug = data.slug
      ? data.slug
      : data.simplifi_conversion_event_id
        ? data.simplifi_conversion_event_id
        : "";
    if (!slug) {
      return "";
    }

    if (this.props.match.params.propertySlug !== undefined) {
      return (
        "/properties/view/" +
        this.props.match.params.propertySlug +
        "/simplifi-leads/view/" +
        slug
      );
    }

    const outsidePropertySlug = this.state.property_slug
      ? this.state.property_slug
      : data.property_slug
        ? data.property_slug
        : "";

    if (!outsidePropertySlug) {
      return "";
    }

    return "/simplifi-leads/view/" + outsidePropertySlug + "/" + slug;
  };

  onClickRow = (event, data, rowIndex) => {
    const returnUrl = this.rowClickedHandler(data);
    if (returnUrl) {
      this.props.history.push(returnUrl);
    }
  };

  render() {
    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        color:
          state.isSelected && state.isFocused
            ? "white"
            : state.isSelected
              ? "black"
              : state.isFocused && "white",
        backgroundColor:
          state.isSelected && state.isFocused
            ? "black"
            : state.isFocused && "black",
      }),
    };

    return (
      <React.Fragment>
        <main>
          <Container className="innter-container">
            <div className="d-flex flex-column">
              <div className="row row-xs mg-t-0 pd-t-0 pd-lg-l-15 pd-xs-l-0">
                {this.props.match.params.propertySlug !== undefined ? (
                  <div className="col-md-2 left">
                    <div className="child-menu-section">
                      <CalendarSidebar
                        property_slug={this.state.property_slug}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="col-md-2 left">
                    <div className="child-menu-section">
                      <AllPropertyReservationSidebar
                        property_slug={this.state.property_slug}
                      />
                    </div>
                  </div>
                )}

                <div
                  className={
                    this.props.match.params.propertySlug !== undefined
                      ? "col-md-10 right"
                      : "col-md-12"
                  }
                >
                  <div className="col-md-12 mg-t-20 mg-b-10"></div>
                  <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 pd-l-15 pd-r-0">
                    <div className="dashbaord-pageHeadertitle d-flex justify-content-between align-items-center flex-wrap mg-b-0">
                      <h3>Marketing Conversion</h3>
                      <div className="d-flex flex-wrap justify-content-end pd-l-0 pd-r-0 mg-b-0">
                        <button
                          onClick={this.searchToggle}
                          className="btn-success-outline-small ml-3"
                        >
                          <img src={filterIcon} alt="filterIcon" /> Search
                        </button>
                      </div>
                    </div>
                  </div>

                  {this.props.match.params.propertySlug === undefined ? (
                    <div className="row pd-lg-l-15 pd-xs-l-15">
                      <div className="col-xxl-2 col-sm-3 pd-lg-r-0 pd-xs-r-15 pd-lg-l-45 pd-xs-l-15">
                        <OutSidePropertySelectBox
                          propertySlug={this.getPropertySlug.bind(this)}
                          outSidePropertySlug={this.state.outSidePropertySlug}
                        />
                      </div>
                      <div className="col-xxl-10 col-md-9 col-sm-8 pd-r-15 pd-l-15">
                        {this.state.is_search === 1 ? (
                          <div className="col-xxl-12 col-sm-12 pd-r-0 pd-lg-r-30 pd-xs-l-30 d-inline-flex align-items-start justify-content-end justify_mob_filter scrolling-carousel">
                            <div className="custm-filter">
                              <div>
                                <label className="form-label text-left pd-b-2 mb-0">
                                  Search Applied On
                                </label>
                              </div>
                              <div className="filter_bg_cust">
                                {this.state.module_search.map((item, i) => (
                                  <span key={i}>{item}</span>
                                ))}
                                <button
                                  onClick={this.clearFilter}
                                  className="btn-fliter-clear"
                                >
                                  Clear
                                </button>
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="col-xxl-12 pd-r-15 pd-l-15">
                      {this.state.is_search === 1 ? (
                        <div className="col-xxl-12 col-sm-12 pd-lg-r-15 pd-lg-l-30 d-inline-flex align-items-start justify-content-end justify_mob_filter scrolling-carousel">
                          <div className="custm-filter">
                            <div>
                              <label className="form-label text-left pd-b-2 mb-0">
                                Search Applied On
                              </label>
                            </div>
                            <div className="filter_bg_cust">
                              {this.state.module_search.map((item, i) => (
                                <span key={i}>{item}</span>
                              ))}
                              <button
                                onClick={this.clearFilter}
                                className="btn-fliter-clear"
                              >
                                Clear
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  )}

                  <div className="scrolling-carousel pd-xs-l-0 pd-xs-r-0 pd-lg-l-30 pd-lg-r-15">
                    <div className="dashboardRightcard background-none pt-0 pl-4 pd-r-15">
                      <div className="col-md-12pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-0">
                        <Alerts
                          show={this.state.showAlertModal}
                          type={this.state.alertModalType}
                          title={this.state.alertModalTitle}
                          message={this.state.alertModalMessage}
                        />
                      </div>
                      {this.state.total_record > 0 ||
                      this.state.filter_value !== "" ? (
                        <div className="mg-t-18 brandList row d-block pd-xs-l-0 pd-xs-r-0 pd-lg-l-0 pd-lg-r-0">
                          <div className="pd-lg-l-0 pd-lg-r-0 pd-xs-l-30 pd-xs-r-15">
                            <ReactDatatable
                              className="table mg-b-30 pd-b-2 add-no-wrap reservationTable table_last_row"
                              config={this.state.config}
                              records={this.state.records}
                              extraButtons={this.state.extraButtons}
                              dynamic={true}
                              loading={this.state.loading}
                              total_record={this.state.total_record}
                              columns={this.state.columns}
                              onRowClicked={this.onClickRow}
                              onChange={this.tableChangeHandler}
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="Nodatafound m-auto">
                          <div className="col-md-12">
                            <div className="row d-flex justify-content-center flex-column pd-l-0 pd-r-0 mg-b-15 text-center align-items-center">
                              <img
                                className="no-data-image"
                                src={Nodata}
                                alt=""
                              />
                              <p className="az-profile-name-text pl-0 pd-t-5 pd-b-10">
                                No data available
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </main>

        <Modal
          show={this.state.isSearch}
          className="modal-large searchModalbox"
          centered
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              this.filterData();
            }
          }}
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span className="welcomeClose" onClick={this.searchToggle}>
              {global.closee}
            </span>
            <h3 className="text-center">Search Marketing Conversion</h3>
            <div className="row col-12 m-0 pd-lg-l-15 pd-lg-r-15 pd-xs-l-0 pd-xs-r-0">
              <div className="col-lg-6 col-md-6 col-sm-12 pd-lg-l-15 pd-lg-r-15 pd-sm-l-15 pd-sm-r-15 pd-xs-l-0 pd-xs-r-0">
                <InputGroup className="mt-3">
                  <label>Event Type</label>
                  <div className="col-md-12 p-0">
                    <Select
                      styles={customStyles}
                      isClearable={true}
                      menuPlacement="auto"
                      className="multiselect"
                      options={this.state.newEventTypeList}
                      getOptionValue={(option) => `${option.label}`}
                      onChange={(value) => this.handleChangeEventType(value)}
                      value={this.state.selectedEventTypeList}
                      defaultValue={this.state.selectedEventTypeList}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 2,
                        colors: {
                          ...theme.colors,
                          primary: "#fff",
                          primary75: "#000",
                          primary50: "#000",
                          primary25: "#000",
                        },
                      })}
                    />
                  </div>
                </InputGroup>

                {/* <InputGroup className="mt-3">
                  <label>Status</label>
                  <div className="col-md-12 p-0">
                    <Select
                      styles={customStyles}
                      isClearable={true}
                      menuPlacement="auto"
                      className="multiselect"
                      options={this.state.newStatusList}
                      getOptionValue={(option) => `${option.label}`}
                      onChange={(value) => this.handleChangeStatus(value)}
                      value={this.state.selectedStatusList}
                      defaultValue={this.state.selectedStatusList}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 2,
                        colors: {
                          ...theme.colors,
                          primary: "#fff",
                          primary75: "#000",
                          primary50: "#000",
                          primary25: "#000",
                        },
                      })}
                    />
                  </div>
                </InputGroup> */}
              </div>

              <div className="col-lg-6 col-md-6 col-sm-12 pd-lg-l-15 pd-lg-r-15 pd-sm-l-15 pd-sm-r-15 pd-xs-l-0 pd-xs-r-0">
                {/* <InputGroup className="mt-3">
                  <label>Click ID</label>
                  <div className="col-md-12 p-0">
                    <Form.Control
                      name="click_id"
                      value={this.state.click_id}
                      onChange={this.changeHandler}
                      className="form-control max_width_100"
                      id="inlineFormInput"
                      type="text"
                      maxLength="255"
                      autoComplete="off"
                    />
                  </div>
                </InputGroup> */}

                <InputGroup className="mt-3">
                  <label>Confirmation Code</label>
                  <div className="col-md-12 p-0">
                    <Form.Control
                      name="reservation_slug"
                      value={this.state.reservation_slug}
                      onChange={this.changeHandler}
                      className="form-control max_width_100"
                      id="inlineFormInput"
                      type="text"
                      maxLength="80"
                      autoComplete="off"
                    />
                  </div>
                </InputGroup>
              </div>
            </div>

            <div className="d-flex justify-content-center mt-3 row">
              <button
                type="button"
                className="m-0 btn btn-outline-light btn-block"
                onClick={this.searchToggle}
              >
                Cancel
              </button>
              <button
                type="button"
                className="m-0 btn btn btn-success btn-block"
                onClick={this.filterData}
              >
                Search
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}

export default SimplifiLeads;
